import React, { useState } from "react";
import Spinner from "../../../../../components/UI/Spinner/Spinner";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { ImportArea } from "../../../../../components/Wrapper/Header/HeaderBottom/components";
import xlsFile from "../../../../../assets/images/components/common/xlsFile.png";
import assort from "../../../../../assets/images/pages/Products/assort.svg";
import { useHistory } from "react-router-dom";

const Import = (props) => {
  const history = useHistory();
  const { merchantId, shopId } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const downloadXlsTemplate = () => {
    window.open(
      "https://adminsamo.com.ua/img/DataImportTemplate.xlsx",
      "_blank",
    );
  };

  return (
    <div className="import-container">
      {loading && (
        <div
          style={{
            width: "100%",
            height: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner />
        </div>
      )}

      <div className="titleBox">
        <img src={assort} alt="" />
        <p>Імпорт</p>
      </div>

      <ImportArea
        setImportMode={props.setImportMode}
        setImportLoading={props.setImportLoading}
        setImportError={props.setImportError}
        setImportSuccessMessage={props.setImportSuccessMessage}
      />

      <div className="docTemplateWrap">
        <div className="docTemplateBox">
          <div className="docTemplate">
            <div className="buttonWrap">
              <div className="buttonBox" onClick={downloadXlsTemplate}>
                <img className="xlsFileIcon" src={xlsFile} alt="fileTemplate" />
                <div className="buttonDescr">
                  Скачати
                  <br />
                  шаблон
                </div>
              </div>
            </div>
            <div className="templateText">
              Завантаживши XLS-файл з шаблоном, заповніть документ відповідно до
              полів та колонок шаблону, видаливши інструкцію-пояснення на правій
              стороні, при збереженні файлу - експортуйте в CSV-формат і
              завантажте його у веб-панель SAMO, обравши відповідний варіант
              імпорту.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Import;
